import React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import logo from "../../assets/images/logo.JPG"; 

import { publicStaffRegistrationService } from "../../services/api-service";

const StaffSelfRegistration = () => {
  const [formData, setFormData] = useState({
    employeeId: "", // <-- NEW FIELD
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    department: "Sales"
  });
  const [imageBase64, setImageBase64] = useState(null);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleCameraCapture = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImageBase64(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!imageBase64) {
      toast.warn("Please take a quick selfie to activate your staff ID!");
      return;
    }

    setLoading(true);
    try {
      await publicStaffRegistrationService({
        staff_id: formData.employeeId, // <-- NOW MAPPED TO EMPLOYEE ID
        first_name: formData.firstName,
        last_name: formData.lastName,
        mobile_no: formData.phone,
        email: formData.email,
        department: formData.department,
        images: [imageBase64]
      });
      
      setSuccess(true);
    } catch (error) {
      toast.error(error.response?.data?.detail || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div style={{ textAlign: "center", padding: "50px 20px", fontFamily: "'Inter', sans-serif", backgroundColor: "#f8fafc", minHeight: "100vh" }}>
        <h1 style={{ color: "#4318FF", fontSize: "80px", margin: "0 0 20px" }}>✓</h1>
        <h2 style={{ color: "#2B3674", fontWeight: "800" }}>Onboarding Complete!</h2>
        <p style={{ color: "#A3AED0", fontWeight: "500" }}>Your staff profile is now active. Welcome to the team!</p>
      </div>
    );
  }

  return (
    <div style={{ maxWidth: "450px", margin: "0 auto", padding: "20px", fontFamily: "'Inter', sans-serif", backgroundColor: "#f8fafc", minHeight: "100vh" }}>
      <ToastContainer position="top-center" />
      
      <div style={{ backgroundColor: "white", padding: "30px", borderRadius: "20px", boxShadow: "0 10px 25px rgba(0,0,0,0.05)" }}>
        
        <div style={{ textAlign: "center", marginBottom: "20px" }}>
          <img src={logo} alt="Company Logo" style={{ maxWidth: "180px", maxHeight: "80px", objectFit: "contain" }} />
        </div>

        <h2 style={{ color: "#2B3674", margin: "0 0 10px", textAlign: "center", fontWeight: "800" }}>Staff Onboarding</h2>
        <p style={{ color: "#A3AED0", textAlign: "center", marginBottom: "30px", fontSize: "14px", fontWeight: "500", lineHeight: "1.5" }}>
          Please complete your details to register for facial recognition attendance.
        </p>

        <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
          {/* NEW EMPLOYEE ID FIELD */}
          <input required name="employeeId" placeholder="Employee ID" value={formData.employeeId} onChange={handleInputChange} style={inputStyle} />
          
          <input required name="firstName" placeholder="First Name" value={formData.firstName} onChange={handleInputChange} style={inputStyle} />
          <input required name="lastName" placeholder="Last Name" value={formData.lastName} onChange={handleInputChange} style={inputStyle} />
          <input required name="phone" type="tel" placeholder="Phone Number" value={formData.phone} onChange={handleInputChange} style={inputStyle} />
          <input name="email" type="email" placeholder="Email Address (Optional)" value={formData.email} onChange={handleInputChange} style={inputStyle} />
          
          <select required name="department" value={formData.department} onChange={handleInputChange} style={inputStyle}>
            <option value="" disabled>Select Department</option>
            <option value="Sales">Sales</option>
            <option value="Management">Management</option>
            <option value="Trainers">Trainers</option>
            <option value="Housekeeping">Housekeeping</option>
            <option value="Security">Security</option>
            <option value="Front Desk">Front Desk</option>
          </select>

          <div style={{ marginTop: "15px", textAlign: "center" }}>
            <label style={{ 
              display: "block", 
              backgroundColor: imageBase64 ? "#e6fbf4" : "#4318FF", 
              color: imageBase64 ? "#05CD99" : "white", 
              border: imageBase64 ? "2px solid #05CD99" : "none",
              padding: "16px", borderRadius: "12px", fontWeight: "700", cursor: "pointer",
              transition: "all 0.3s ease"
            }}>
              {imageBase64 ? "📸 Face Captured! (Tap to retake)" : "📸 Tap to Scan Face"}
              <input type="file" accept="image/*" capture="user" onChange={handleCameraCapture} style={{ display: "none" }} />
            </label>
            
            {imageBase64 && (
              <img src={imageBase64} alt="Selfie preview" style={{ width: "120px", height: "120px", objectFit: "cover", borderRadius: "50%", marginTop: "20px", border: "4px solid #4318FF", boxShadow: "0 4px 10px rgba(67, 24, 255, 0.3)" }} />
            )}
          </div>

          <button type="submit" disabled={loading} style={{ 
            marginTop: "25px", 
            backgroundColor: loading ? "#A3AED0" : "#2B3674", 
            color: "white", padding: "16px", border: "none", borderRadius: "12px", 
            fontWeight: "700", fontSize: "16px", cursor: loading ? "not-allowed" : "pointer",
            transition: "all 0.3s ease"
          }}>
            {loading ? "Registering..." : "Complete Registration"}
          </button>
        </form>
      </div>
    </div>
  );
};

const inputStyle = {
  padding: "16px", borderRadius: "12px", border: "1px solid #E2E8F0", 
  fontSize: "15px", backgroundColor: "#F8FAFC", outline: "none", color: "#2B3674", fontWeight: "500"
};

export default StaffSelfRegistration;
